"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants = __importStar(require("./constants"));
const SearchJSONBuilder_1 = __importDefault(require("./SearchJSONBuilder"));
const types_1 = require("./types");
const utils_1 = require("../utils");
class SearchOpenSearchQueryBuilder extends SearchJSONBuilder_1.default {
    // --------------------------------- public methods ------------------------------------------------------------------
    getOpenSearchQuery() {
        const query = { query: {} };
        const parsedQuery = this.getJSON();
        const boolSearchQuery = {};
        const freeTextQuery = this.getMultiMatchQuery(parsedQuery);
        const filterQuery = this.getFilterQuery(parsedQuery);
        const sizeQuery = parsedQuery[constants.SEARCH_SIZE];
        const fromQuery = parsedQuery[constants.SEARCH_FROM];
        const sortQuery = this.getSortClause(parsedQuery);
        const searchAfterQuery = this.getSearchAfterClause(parsedQuery);
        const aggsQuery = this.getAggsClause(parsedQuery);
        if (freeTextQuery && freeTextQuery.query !== '') {
            boolSearchQuery.must = [{ multi_match: freeTextQuery }];
        }
        if (filterQuery.length > 0) {
            boolSearchQuery.filter = filterQuery;
        }
        if (Number.isInteger(sizeQuery)) {
            query.size = sizeQuery;
        }
        if (Number.isInteger(fromQuery)) {
            query.from = fromQuery;
        }
        if (!(0, utils_1.isEmptyObject)(sortQuery)) {
            query.sort = sortQuery;
            if ((searchAfterQuery).length > 0) {
                query.search_after = this.getSearchAfterClause(parsedQuery);
            }
        }
        if (!(0, utils_1.isEmptyObject)(aggsQuery)) {
            query.aggs = aggsQuery;
        }
        if (!(0, utils_1.isEmptyObject)(boolSearchQuery)) {
            query.query.bool = boolSearchQuery;
        }
        else {
            query.query.match_all = {};
        }
        return query;
    }
    // --------------------------------- private methods -----------------------------------------------------------------
    getAggsClause(parsedQuery) {
        var _a;
        const aggs = {};
        (_a = parsedQuery[constants.SEARCH_AGGREGATIONS]) === null || _a === void 0 ? void 0 : _a.forEach(agg => {
            aggs[agg[constants.SEARCH_AGGREGATION_NAME]] = this.getAggsByType(this.switchKeywordInField(agg[constants.SEARCH_AGGREGATION_FIELD]), agg[constants.SEARCH_AGGREGATION_TYPE], agg[constants.SEARCH_AGGREGATION_SIZE]);
        });
        return aggs;
    }
    getAggsByType(field, type, size) {
        switch (type) {
            case types_1.AggregationsTypes.terms:
                return this.getTermAggregation(field, size);
            case types_1.AggregationsTypes.avg:
                return {
                    avg: {
                        field
                    }
                };
            case types_1.AggregationsTypes.cardinality:
                return {
                    cardinality: {
                        field
                    }
                };
            case types_1.AggregationsTypes.max:
                return {
                    max: {
                        field
                    }
                };
            case types_1.AggregationsTypes.min:
                return {
                    min: {
                        field
                    }
                };
            case types_1.AggregationsTypes.sum:
                return {
                    sum: {
                        field
                    }
                };
            case types_1.AggregationsTypes.stats:
                return {
                    stats: {
                        field
                    }
                };
            case types_1.AggregationsTypes.valueCount:
            default:
                return {
                    value_count: {
                        field
                    }
                };
        }
    }
    getTermAggregation(field, size) {
        const agg = { terms: { field } };
        if (size && Number.isInteger(size)) {
            agg.terms.size = size;
        }
        return agg;
    }
    getSortClause(parsedQuery) {
        const parsedSort = parsedQuery[constants.SEARCH_SORT];
        const sorting = {};
        parsedSort === null || parsedSort === void 0 ? void 0 : parsedSort.forEach(sort => {
            sorting[sort[constants.SEARCH_SORT_FIELD]] = sort[constants.SEARCH_SORT_DIRECTION] || 'asc';
        });
        return sorting;
    }
    getSearchAfterClause(parsedQuery) {
        var _a;
        return ((_a = parsedQuery[constants.SEARCH_SORT]) !== null && _a !== void 0 ? _a : [])
            .map(sort => sort[constants.SEARCH_SORT_SEARCH_AFTER] || '')
            .filter(s => s !== '');
    }
    getMultiMatchQuery(parsedQuery) {
        var _a, _b, _c;
        const term = parsedQuery[constants.SEARCH_QUERY];
        return (term && {
            query: (_a = term[constants.SEARCH_QUERY_TERM]) !== null && _a !== void 0 ? _a : '',
            fields: (_c = (_b = term[constants.SEARCH_QUERY_FIELDS]) === null || _b === void 0 ? void 0 : _b.map(f => `${f[constants.SEARCH_FIELDS_FIELD]}^${f[constants.SEARCH_FIELDS_BOOST] || '1'}`)) !== null && _c !== void 0 ? _c : [],
            type: 'bool_prefix',
        });
    }
    getFilterQuery(parsedQuery) {
        var _a, _b;
        const boolFilters = { bool: {} };
        const orFilters = this.getFilterQueryOrClause(((_a = parsedQuery[constants.SEARCH_FILTERS]) === null || _a === void 0 ? void 0 : _a.filter(f => f[constants.SEARCH_FILTERS_OPERATOR] === 'OR')) || []);
        const andFilters = this.getFilterQueryAndClause(((_b = parsedQuery[constants.SEARCH_FILTERS]) === null || _b === void 0 ? void 0 : _b.filter(f => f[constants.SEARCH_FILTERS_OPERATOR] === 'AND')) || []);
        const mustNotFilter = this.getFilterQueryEmptyClause(parsedQuery[constants.SEARCH_FILTERS] || []);
        const mustFilters = orFilters.concat(andFilters);
        if (mustNotFilter.length > 0) {
            boolFilters.bool.must_not = mustNotFilter;
        }
        if (mustFilters.length > 0) {
            boolFilters.bool.must = mustFilters;
        }
        return mustNotFilter.length > 0 || mustFilters.length > 0 ? [boolFilters] : [];
    }
    getFilterQueryOrClause(filters) {
        return this.filterEmptyValues(filters)
            .map(f => {
            const field = this.switchKeywordInField(f[constants.SEARCH_FILTERS_FIELD]);
            return {
                terms: {
                    [field]: f[constants.SEARCH_FILTERS_VALUES],
                }
            };
        });
    }
    getFilterQueryAndClause(filters) {
        return this.filterEmptyValues(filters)
            .map(f => {
            const field = this.switchKeywordInField(f[constants.SEARCH_FILTERS_FIELD]);
            return f[constants.SEARCH_FILTERS_VALUES]
                .filter(value => value !== '')
                .map(value => {
                return {
                    term: {
                        [field]: value,
                    }
                };
            });
        }).flat();
    }
    getFilterQueryEmptyClause(filters) {
        return filters
            .filter(filter => filter[constants.SEARCH_FILTERS_VALUES].every(value => value === ''))
            .map(f => {
            const field = this.removeKeywordPrefix(f[constants.SEARCH_FILTERS_FIELD]);
            return {
                exists: {
                    field
                }
            };
        });
    }
    filterEmptyValues(filters) {
        return filters
            .filter(filter => filter[constants.SEARCH_FILTERS_VALUES].filter(value => value !== '').length > 0);
    }
    switchKeywordInField(field) {
        return field.startsWith('k:') ? `${field.substring(2)}.keyword` : field;
    }
    removeKeywordPrefix(field) {
        return field.startsWith('k:') ? `${field.substring(2)}` : field;
    }
}
exports.default = SearchOpenSearchQueryBuilder;
